











































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import { SIGN_UP_REQUEST } from '@/store/auth';
import { ErrorHandler, FormError } from '@/modules/FormError';
import { WORK } from '@/router/work';
import Http from '@/Http';

@Component({
  components: { Dialog }
})
export default class SignUp extends Vue implements FormError {
  @Prop() private showDialog!: boolean;
  public form = {
    phone: '',
    password: '',
    password_confirmation: '',
    code: '',
    privacy_policy: false,
    name: '',
    last_name: ''
  };
  public showPassword:boolean = false;
  public errorMessage:string = '';
  public loading: boolean = false;
  public sendSms:boolean = false;

  public $refs!: {
    register: HTMLFormElement
  };

  @Watch('form', { immediate: true, deep: true })
  onFormChanged () {
    this.errorMessage = '';
  }

  public gotCode () {
    this.loading = true;
    (new Http()).post({ url: 'create-confirm-code', data: { ...this.form } })
      .then(res => {
        this.loading = false;
        this.sendSms = true;
      })
      .catch(e => new ErrorHandler(this, e));
  }

  register () {
    this.loading = true;
    this.$store.dispatch(SIGN_UP_REQUEST, this.form).then(() => {
      this.$emit('close');
      this.$router.push({ name: WORK });
    }).catch(e => new ErrorHandler(this, e));
  }

  setErrors (data: any): void {
    this.$refs.register.setErrors(data);
  }
}
